import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { AttachmentIcon } from "services/Recruit/assets/svg/AttachmentIcon";
import { Field, Formik, Form } from "formik";
import CustomDatePicker from "common/components/datePicker/CustomDatePicker";
import { useEffect, useState } from "react";
import TextEditor from "common/components/textEditor/TextEditor";
import { useNavigate, useParams } from "react-router-dom";
import { constant } from "common/constant";
import { interviewTabsData } from "services/Recruit/data/tabsData";
import { dropdownOptions } from "services/Recruit/data/dropdownData";
import FileUpload from "common/components/fileUpload/FileUpload";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { addRecruitmentProfile } from "common/redux/reducers/recruitmentSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { CREATE_JOB_OPENING_INITIAL_VALUES } from "common/initialValues/formInitialValues";
import { toast } from "react-toastify";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { putApi } from "common/services/api";
import { InterviewData } from "services/Recruit/data/interviewData";
import { ApplicationSchema } from "services/Recruit/schema/applicationSchema";
import { interviewerOptions } from "services/Recruit/data/dropdownData";
import { interviewRoundOptions } from "services/Recruit/data/dropdownData";
import { interviewTypeOptions } from "services/Recruit/data/dropdownData";
import { candidateOptions } from "services/Recruit/data/dropdownData";
import { applicationTabsData } from "services/Recruit/data/tabsData";
import { countryOptions } from "services/Recruit/data/dropdownData";
import { totalExperienceOptions } from "services/Recruit/data/dropdownData";
import { noticePeriodOptions } from "services/Recruit/data/dropdownData";
import { jobOpeningStatusOptions } from "services/Recruit/data/dropdownData";
import { applicationSourceOptions } from "services/Recruit/data/dropdownData";
import { recruitConstant } from "services/Recruit/constant";


const ApplicationCreate = () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { id } = useParams();
    const [jobData, setJobData] = useState(null);

    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    const handleNext = () => {
        if (activeTabIndex < 3) {
            setActiveTabIndex(activeTabIndex + 1);
        }
    };

    const handleBack = () => {
        if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
        }
    }

    const handleFileChange = (dispatch, setFieldValue, fieldName) => async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const result = await dispatch(uploadAttachment({ file, setFieldValue, fieldName }));
                const attachmentId = result.payload;
                if (attachmentId) {
                    setFieldValue(fieldName, attachmentId);
                }
            } catch (error) {
            }
        }
    };

    const EditData = async (values) => {
        try {
            let response = await putApi(
                `${API_PATHS.POST_RECRUITMENT_PROFILES}/${id}`,
                values
            );
            if (response.status === 200) {
                navigate("/recruit/application");
            }
        } catch (e) {
            toast.error(constant.somethingWrong);
        } finally {
        }
    };
    const handleSubmit = (values, { resetForm }, navigate, id) => {
        if (id) {
            navigate("/recruit/application");
        } else {
            // dispatch(addRecruitmentProfile({ values, resetForm, navigate })); // Uncomment if using Redux
            navigate("/recruit/application");
        }
        resetForm();
    };
    return (
        <div className="pt-75">
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/application")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{id ? constant.editJobApplication : constant.createApplication}</Text>
                        </Box>
                    </Box>

                    <Formik
                        enableReinitialize
                        initialValues={
                            InterviewData
                                ? {
                                    ...InterviewData,
                                    department: InterviewData.id || "",
                                }
                                : CREATE_JOB_OPENING_INITIAL_VALUES
                        }
                        validationSchema={ApplicationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {applicationTabsData.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="job">{constant.job}<span className="astrick">*</span></FormLabel>
                                                        <Field name="job">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select value={field.value || ""} {...field} defaultValue="">
                                                                        <option selected hidden value="">{constant.selectJob}</option>
                                                                        {dropdownOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="name">
                                                            {recruitConstant.name}
                                                            <span className="astrick">*</span>
                                                        </FormLabel>
                                                        <Field name="name">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.namePlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="email">
                                                            {recruitConstant.email} <span className="astrick">*</span>
                                                        </FormLabel>
                                                        <Field name="email">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.emailPlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="phone">{recruitConstant.phone}<span className="astrick">*</span></FormLabel>
                                                        <Field name="phone">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="number"
                                                                        placeholder={recruitConstant.phonePlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="location">{recruitConstant.location}<span className="astrick">*</span></FormLabel>
                                                        <Field name="location">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.enterLocation}</option>
                                                                        {countryOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="totalExperience">{recruitConstant.totalExperience}<span className="astrick">*</span></FormLabel>
                                                        <Field name="totalExperience">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.selectTotalExp}</option>
                                                                        {totalExperienceOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="currentLocation">{recruitConstant.currentLocationLabel}<span className="astrick">*</span></FormLabel>
                                                        <Field name="currentLocation">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectCurrentLocation}</option>
                                                                        {countryOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="noticePeriod">{recruitConstant.noticePeriod}<span className="astrick">*</span></FormLabel>
                                                        <Field name="noticePeriod">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.enterNoticePerios}</option>
                                                                        {noticePeriodOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="status">{recruitConstant.status}<span className="astrick">*</span></FormLabel>
                                                        <Field name="status">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectStatus}</option>
                                                                        {jobOpeningStatusOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="applicationSource">{recruitConstant.applicationSource}<span className="astrick">*</span></FormLabel>
                                                        <Field name="applicationSource">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectApplicationSource}</option>
                                                                        {applicationSourceOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                            <Box className="createJobOpening-tabsPanelFooter">
                                              <Button  className="backBtn" onClick={()=>navigate("/recruit/application")}>{recruitConstant.back}</Button>
                                                <Button className="nextBtn" variant="primary" onClick={handleNext}>{constant.next}</Button>
                                            </Box>
                                        </TabPanel>

                                        {/* Description information */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">

                                                <Flex gap={'20px'} direction="column">
                                                    <Box w={'100%'}>
                                                        <FormLabel htmlFor="title">{constant.CoverLetter}<span className="astrick">*</span></FormLabel>
                                                        <Field name="title">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Textarea
                                                                        className="coverLetter"
                                                                        placeholder={recruitConstant.CoverLetter}
                                                                        size="md"
                                                                        resize="none"
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>

                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn"   onClick={()=>navigate("/recruit/application")}>{recruitConstant.back}</Button>
                                                <Button
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                    onClick={()=>navigate("/recruit/application")}
                                                >
                                                    {id ? recruitConstant.update : recruitConstant.save}
                                                </Button>
                                            </Box>

                                        </TabPanel>
                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </div>
    );
};

export default ApplicationCreate;
